import { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useTemplatesListState } from '../../context/UseTemplatesListContext';
import ArchivedTemplateSidebar from './ArchivedTemplateSidebar/ArchivedTemplateSidebar';
import { CommonSelectedTemplateSidebar } from './CommonSelectedTemplateSidebar';
import { OffsiteOptions } from './OffsiteOptions';
import { OnsiteOptions } from './OnsiteOptions';
import { useFeatureFlags } from 'core/app/AppContext';

// Create Panel
export const SupportedLanguageButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: center;
  justify-content: space-evenly;
`;

export const SupportedLanguageButtonItem = styled.div`
  align-self: auto;
  flex: 0 1 auto;
  margin: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
`;

export function SelectedTemplateSidebar() {
  const { flagEnabled } = useFeatureFlags();
  const { selectedTemplate } = useTemplatesListState();
  const { siteId } = useParams<{ siteId: string }>();
  const [showModal, setShowModal] = useState(false);

  if (!selectedTemplate) {
    return null;
  }

  const isArchived = selectedTemplate.isArchived;

  switch (selectedTemplate.channel) {
    case 'onsite':
      return isArchived ? (
        <ArchivedTemplateSidebar showModal={showModal} setShowModal={setShowModal} />
      ) : (
        <CommonSelectedTemplateSidebar
          showModal={showModal}
          setShowModal={setShowModal}
          showEmbeddedOptions={flagEnabled('ld-embedded-content')}
          additionalContent={
            flagEnabled('ld-clone-onsite-templates') ? <OnsiteOptions setShowModal={setShowModal} /> : undefined
          }
        />
      );
    default:
      return isArchived ? (
        <ArchivedTemplateSidebar showModal={showModal} setShowModal={setShowModal} />
      ) : (
        <CommonSelectedTemplateSidebar
          showEmbeddedOptions={false}
          showEdit={selectedTemplate.siteId === siteId}
          showModal={showModal}
          setShowModal={setShowModal}
          additionalContent={<OffsiteOptions setShowModal={setShowModal} />}
        />
      );
  }
}
